import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getTeamMembers } from '@/services/strapi/team-members';

export const teamMembers = createQueryKeys('teamMembers', {
  list: {
    queryKey: null,
    queryFn: getTeamMembers,
  },
});
